import { useSubscription } from '@apollo/client/react'
import { AdminAPI, getFragment, SharedAPI } from '@guestgoodie/graphql'

import { useAuth } from '@/features/auth'

export function useFileSubscription() {
  const { isSignedIn, hasOrg } = useAuth()

  useSubscription(AdminAPI.file.UPDATED, {
    skip: !isSignedIn || !hasOrg,
    ignoreResults: true,
    onData({ client, data }) {
      const file = getFragment(
        SharedAPI.file.FILE_FRAGMENT,
        data.data?.fileUpdated
      )

      if (file) {
        client.cache.modify({
          id: client.cache.identify(file),
          fields: {
            state: () => file.state,
            contentType: () => file.contentType,
            extension: () => file.extension,
            processingMetadata: () => file.processingMetadata
          }
        })
      }
    },
    onError(error) {
      console.error(
        '[features/files/hooks/useFileSubscription]',
        'useSubscription error',
        error
      )
    }
  })
}
